<script>
import { toasterMethods, voeReportMethods } from '@state/helpers'
import constant from '@constants/constant'
import accesslevels from '@utils/accesslevels'

export default {
  props: {
    customerId: {
      type: [Number, String],
      default: '',
    },
    customerUserId: {
      type: [Number, String],
      default: '',
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    productAddOns: {
      type: Array,
      default: Array,
    },
    orderData: {
      type: Object,
      default: Object,
    },
    enableManualVerificationMandatory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmTitle: constant.imageHeaderConf,
      confirmMessage: constant.cancelConfirmationMessage,
      showModalConfirm: false,
      routeId: '',
      custUserId: '',
      selected: '',
      obtainVoe: false,
      referenceNumber: '',
      borrowerFirstName: '',
      borrowerMiddleName: '',
      borrowerLastName: '',
      borrowerSSN: '',
      salaryKey: '',
      employerName: '',
      employerCode: '',
      employeeId: '',
      verified: '',
      employmentType: '',
      permissiblePurposeId: '',
      verifyFor: 'ActiveOnly',
      previousOrder: '',
      lastDigitsOfSSN: '',
      uploadDocumentModal: false,
      signedFileName: '',
      fileData: '',
      fileType: '',
      fileName: '',
      signedfile: null,
      isDisabled: false,
      displayAlert: false,
      showSpinner: false,
      borrowersInfo: [],
      saveAndAddNewData: [],
      resultmessage: '',
      showmessage: false,
      reSubmitOrder: false,
      subOrderId: '',
      orderId: '',
      isAuthFormRequired: true,
      AuthorizationError: '',
      dismissSecs: 3,
      dismissCountDown: 0,
      borrowerDOB: '',
      borrowerStreetAddress: '',
      borrowerCityName: '',
      borrowerState: '',
      borrowerZip: '',
      borrowerPhoneNumber: '',
      employerType: '',
      employerPhoneNumber: '',
      employerFax: '',
      employerStreetAddress: '',
      employerCityName: '',
      employerState: '',
      employerZip: '',
      hrFirstName: '',
      hrMiddleName: '',
      hrLastName: '',
      hrTitle: '',
      hrPhoneNumber: '',
      hrFax: '',
      hrEmail: '',
      additionalNotes: '',
      stateCode: '',
      employmentTypes: [],
      permissiblePurposes: [
        {
          text: 'Employees Application for Credit',
          value: 'EmployeesApplicationForCredit',
        },
        {
          text: 'Employment Purposes',
          value: 'EmploymentPurposes',
        },
      ],
      employerTypes: [
        { text: 'Current Employer', value: 'CurrentEmployer' },
        { text: 'Previous Employer', value: 'PreviousEmployer' },
      ],
      obtainVoes: [
        { text: 'Yes', value: true },
        { text: 'No', value: false },
      ],
      verifyFors: [
        { text: 'Current Employer(s)', value: 'ActiveOnly' },
        { text: 'Previous employer(s)', value: 'InActiveOnly' },
        { text: 'Both - Current & previous', value: 'BothActive' },
        { text: 'Employment Select', value: 'EmploymentSelect' },
      ],
      authorizedFileItems: [{ file_name: 'dssdsdsd', file_actions: '' }],
      authorizedTableFields: [
        { key: 'file_name', label: 'File Name', thClass: 'text-left' },
        { key: 'file_actions', label: 'Actions', thClass: 'text-center' },
      ],
      saveAndAddNewBorrowerFields: [
        { key: 'employeementType', label: 'Order Type', thClass: 'text-left' },
        { key: 'borrowerName', label: 'Ordered For', thClass: 'text-left' },
        { key: 'Actions', label: 'Actions', thClass: 'text-center' },
      ],
    }
  },
  computed: {
    CURRENT_USER() {
      return this.$store.state.auth.currentUser
        ? this.$store.state.auth.currentUser.userInfo || {}
        : {}
    },
    placeholders() {
      return {
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        ssn: 'xxx-xx-xxxx',
        salaryKey: 'Salary Key',
        email: 'Email ID',
        streetAddress: 'Street Address',
        cityName: 'City Name',
        zip: 'xxxxx-xxxx',
        phoneNumber: '(xxx) xxx-xxxx',
        hrTitle: 'Title',
        fax: 'xxxxx-xxxx',
        referenceNumber: 'Reference Number',
        employerNumber: '',
        employerName: 'Employer Name',
        employerCode: 'Employer Code',
        employeeId: 'Employee ID',
        previousOrder: 'Previous Order#',
        lastDigitsOfSSN: 'xxxx',
      }
    },
    states() {
      return this.$_allStates
    },
    isCustRequestor() {
      return accesslevels(9)
    },
    isCustProcessor() {
      return accesslevels(8)
    },
  },
  created() {
    this.getAuthFormValidation()
    this.productAddOns.forEach((item) => {
      if (item.changeable === true) {
        this.employmentTypes.push({
          text: item.name,
          value:
            item.name === 'Employment Plus Income'
              ? 'EmploymentIncome'
              : item.name,
        })
      }
    })
    this.employmentType = this.employmentTypes[0].value
    this.onEmploymentTypeChange(this.employmentType)
  },

  mounted() {
    if (
      (this.orderData && this.orderData.orderId) ||
      this.enableManualVerificationMandatory
    ) {
      this.reSubmitVoEData(this.orderData)
    }
    if (!this.enableManualVerificationMandatory) {
      this.reSubmitOrder = false
    }
  },

  methods: {
    ...voeReportMethods,
    ...toasterMethods,
    async getModal(message, type, method) {
      await this.$refs.msg.showAsync(message, type, 'Ok').then(() => {
        if (method) {
          method()
        }
      })
    },
    getStateCode(state) {
      if ((this.state !== '') & (this.state !== null)) {
        this.stateCode = this.states.find(
          (x) => x.value === Number(this.state)
        ).stateCode
      }
    },
    isDocumentUploaded() {
      if (!this.fileData && this.isAuthFormRequired) {
        this.getModal('Please Upload PDF', 'Alert')
        return false
      } else {
        return true
      }
    },
    onCancelClick() {
      this.showModalConfirm = true
    },
    hideModalAlert() {
      this.showModalConfirm = false
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    alertDismissed(dismissCountDown) {
      this.showmessage = false
    },

    closeButton() {
      this.isDefault = true
      this.isOpen = false
    },
    clearErrorsAndFeilds() {
      this.employerName = ''
      this.employerCode = ''
      this.employeeId = ''
      this.$validator.reset()
    },
    reSubmitVoEData(voeData) {
      this.reSubmitOrder = true

      this.referenceNumber = voeData.referenceNumber
      this.employmentType = voeData.employmentTypeId
      this.borrowerFirstName = voeData.firstName
      this.borrowerMiddleName = voeData.middleName
      this.borrowerLastName = voeData.lastName

      this.permissiblePurposeId = voeData.permissiblePuposeId
      this.borrowerSSN = voeData.employeeId

      this.salaryKey = voeData.salaryKey
      this.orderId = voeData.orderId
      this.subOrderId = voeData.subOrderId
      this.verifyFor = voeData.verifyOptionId

      this.employeeId = voeData.employeeId
      this.employerCode = voeData.employerCode
      this.employerName = voeData.employerName
      this.employerType = this.employerTypes[0].value

      if (this.employerName !== '') {
        this.obtainVoe = true
      } else {
        this.obtainVoe = false
      }
      if (this.employmentType === 'EmploymentIncome') {
        this.fileName = voeData.authorizationFormName
        this.fileData = voeData.AuthorizationForm
        this.fileType = voeData.AuthorizationFormFileType
      }
      this.onEmploymentTypeChange()
    },
    getAuthFormValidation() {
      this.showSpinner = true
      this.fetchAuthFormValidation({
        customerId: this.customerId,
        customerUserId: this.customerUserId,
      })
        .then((response) => {
          let responseObj = response.data || response
          this.showSpinner = false
          this.isAuthFormRequired = responseObj.validationRequired
        })
        .catch((error) => {
          this.showSpinner = false
          this.autherror = error
          this.setAlert({
            title: constant.imageHeaderError,
            msg: constant.errorMessage,
            variant: constant.errorMessagetype,
          })
        })
    },
    onEmploymentTypeChange(evtvalue) {
      let empType = evtvalue || this.employmentType

      if (!this.reSubmitOrder) {
        this.clearErrorsAndFeilds()
        this.verifyFor = this.verifyFors[0].value
      }

      if (empType === 'Employment') {
        this.verifyFors = [
          { text: 'Current Employer(s)', value: 'ActiveOnly' },
          { text: 'Previous employer(s)', value: 'InActiveOnly' },
          { text: 'Both - Current & previous', value: 'BothActive' },
          { text: 'Employment Select', value: 'EmploymentSelect' },
        ]
      } else if (empType === 'EmploymentIncome') {
        this.verifyFors = [
          { text: 'Current Employer(s)', value: 'ActiveOnly' },
          { text: 'Previous employer(s)', value: 'InActiveOnly' },
          { text: 'Both - Current & previous', value: 'BothActive' },
          { text: 'Mortgage Ultimate', value: 'MortgageUltimate' },
          { text: 'Mortgage Preferred', value: 'MortgagePrefered' },
          { text: 'Employers within 24 months', value: 'Mortgage24Months' },
          { text: 'Employers within 12 months', value: 'Mortgage12Months' },
        ]
      }
    },
    constructBorrowerObj() {
      let result = this.borrowersInfo.filter((info) => {
        return info.SSN === this.borrowerSSN
      })
      if (result.length > 0) {
        this.getModal(
          'Borrower information already saved',
          'Borrower information'
        )
        return false
      }
      let trimedSSN = String(this.borrowerSSN).replace(/-/g, '')
      let borrowers = {
        FirstName: this.borrowerFirstName,
        MiddleName: this.borrowerMiddleName,
        LastName: this.borrowerLastName,
        SSN: trimedSSN,
        SalaryKey: this.salaryKey,
        EmploymentType: this.employmentType,
        EmployeeID: this.obtainVoe ? this.employeeId : trimedSSN,
        VerifyFor: this.verifyFor,
      }
      if (this.employmentType === 'EmploymentIncome') {
        borrowers.AuthorizationFormName = this.fileName
        borrowers.AuthorizationForm = this.fileData
        borrowers.AuthorizationFormFileType = this.fileType
      }
      return borrowers
    },
    buildVoERequest() {
      this.custUserId = this.isCustRequestor
        ? this.CURRENT_USER.userId
        : this.customerUserId
      this.customerId =
        this.isCustProcessor || this.isCustRequestor
          ? this.CURRENT_USER.customerId
          : this.customerId
      if (this.borrowersInfo.length < 1) {
        let results = this.constructBorrowerObj()
        if (!results) return results
        this.borrowersInfo.push(results)
      }

      let voeRequestObj = {
        UserId: this.CURRENT_USER.userId,
        ReferenceNumber: this.referenceNumber,
        PermissiblePurposeId: this.permissiblePurposeId,
        EmployerName: this.employerName,
        EmployerCode: this.employerCode,
        ProductId: this.productId,
        OrderForCustomer: this.customerId,
        OrderForUser: this.custUserId,
      }

      if (
        this.employmentType === 'Employment' ||
        this.employmentType === 'EmploymentIncome'
      ) {
        voeRequestObj.Borrower = this.borrowersInfo
      } else if (this.employmentType === 'Reverify') {
        voeRequestObj.previousOrder = this.previousOrder
        voeRequestObj.lastDigitsOfSSN = this.lastDigitsOfSSN
      }

      if (this.reSubmitOrder) {
        voeRequestObj.subOrderId = this.subOrderId
        voeRequestObj.orderId = this.orderId
      }
      return voeRequestObj
    },
    constructEmployerDetails() {
      this.state = this.employerState
      this.getStateCode(this.state)
      let employerDetailsObj = {
        employerName: this.employerName,
        employerType: this.employerType,
        employerContact: {
          phoneNumber: this.employerPhoneNumber,
          typeId: 0,
          faxNumber: this.employerFax,
        },
        employerAddress: {
          street: this.employerStreetAddress,
          city: this.employerCityName,
          stateId: Number(this.employerState),
          stateCode: this.stateCode,
          zip: this.employerZip,
        },
        employerHrDetails: {
          firstName: this.hrFirstName,
          middleName: this.hrMiddleName,
          lastName: this.hrLastName,
          suffix: 0,
        },
        employerHRContact: {
          phoneNumber: this.hrPhoneNumber,
          typeId: 0,
          faxNumber: this.hrFax,
        },
      }
      return employerDetailsObj
    },
    constructBorrowerObjManual() {
      this.state = this.borrowerState
      this.getStateCode(this.state)

      let borrowerObject = {
        firstName: this.borrowerFirstName,
        middleName: this.borrowerMiddleName,
        lastName: this.borrowerLastName,
        ssn: this.borrowerSSN,
        dateOfBirth: this.borrowerDOB,
        address: {
          street: this.borrowerStreetAddress,
          city: this.borrowerCityName,
          stateId: Number(this.borrowerState),
          stateCode: this.stateCode,
          zip: this.borrowerZip,
        },
        contacts: {
          phoneNumber: this.borrowerPhoneNumber,
          phoneType: 0,
        },
      }
      return borrowerObject
    },
    buildVoEManualRequest() {
      this.custUserId = this.isCustRequestor
        ? this.CURRENT_USER.userId
        : this.customerUserId
      this.customerId =
        this.isCustProcessor || this.isCustRequestor
          ? this.CURRENT_USER.customerId
          : this.customerId

      this.fileData = (this.fileData === undefined) ? '' : this.fileData.replace('data:application/pdf;base64,', '')

      return JSON.stringify({
        userId: this.CURRENT_USER.userId,
        productId: this.productId,
        orderForCustomer: this.customerId,
        orderForUser: this.custUserId,
        referenceNumber: this.referenceNumber,
        permissiblePurposeId: this.permissiblePurposeId,
        employmentType: this.employmentType,

        borrower: this.constructBorrowerObjManual(),

        employerDetails: this.constructEmployerDetails(),

        EmailAddress: this.hrEmail,
        hrTitle: this.hrTitle,
        additionalNotes: this.additionalNotes,
        AuthorizationFormName: this.fileName,
        AuthorizationForm: this.fileData,
        AuthorizationFormFileType: this.fileType,
      })
    },
    onSaveAnotherVOE() {
      this.$validator.validate().then((response) => {
        let isAuthFormValid = true
        if (
          this.employmentType === 'EmploymentIncome' &&
          this.fileData === '' &&
          this.isAuthFormRequired
        ) {
          this.AuthorizationError = "Borrower's Authorization Form is required"
          isAuthFormValid = false
        }
        if (response && isAuthFormValid) {
          let results = this.constructBorrowerObj()
          if (!results) return results

          this.borrowersInfo.push(results)
          this.saveAndAddNewData.push({
            employeementType: this.employmentType,
            borrowerName: this.borrowerFirstName + ' ' + this.borrowerLastName,
          })
        }
      })
    },
    submitManualVerificationReport() {
      var isOrderReportComponentValid = false
      var isVoEReportComponentValid = false
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isVoEReportComponentValid = response
          if (
            isOrderReportComponentValid &&
            isVoEReportComponentValid &&
            that.isDocumentUploaded()
          ) {
            this.showSpinner = true
            that
              .generateVoEManualreports(that.buildVoEManualRequest())
              .then((response) => {
                let respData = response.data || response
                let responseMsg = response.message || response.data.message
                this.routeId = responseMsg
                if (respData.id !== undefined) {
                  this.setAlert({
                    title: constant.imageHeaderSuccess,
                    msg: responseMsg,
                    variant: constant.successMessagetype,
                  })
                  this.$emit('resetOrderReport')
                  this.$router.push({
                    name: 'voeResults',
                    params: {
                      orderId: this.routeId.split(' ')[0],
                      callOrigin: constant.origin.OrderReport,
                    },
                  })
                }
                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.autherror = error
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
              })
          }
        })
      })
    },
    onReportSubmit(selectedValue) {
      if (this.enableManualVerificationMandatory) {
        this.submitManualVerificationReport()
        return
      }
      var isOrderReportComponentValid = false
      var isVoEReportComponentValid = false
      var that = this
      this.$parent.$parent.$validator.validateAll().then((response) => {
        isOrderReportComponentValid = response
        this.$validator.validate().then((response) => {
          if (this.isCustRequestor) {
            isOrderReportComponentValid = response
          }
          isVoEReportComponentValid = response
          if (isOrderReportComponentValid && isVoEReportComponentValid) {
            this.showSpinner = true
            that
              .generateVoEreports(that.buildVoERequest())
              .then((response) => {
                let respData = response.data || response

                if (respData.orderId !== undefined) {
                  this.$emit('resetOrderReport')
                  this.$router.push({
                    name: 'voeResults',
                    params: {
                      orderId: respData.orderId,
                      callOrigin: constant.origin.OrderReport,
                    },
                  })
                }
                this.showSpinner = false
              })
              .catch((error) => {
                this.showSpinner = false
                this.autherror = error
                this.setAlert({
                  title: constant.imageHeaderError,
                  msg: constant.errorMessage,
                  variant: constant.errorMessagetype,
                })
              })
          }
        })
      })
    },
    onChangePdf() {
      this.uploadDocumentModal = false
      this.showSpinner = true
      var files = this.signedfile
      if (!files) {
        this.getModal(constant.emptyPdf, 'Alert')
        this.showSpinner = false
        return
      }
      if (
        files.type !== 'application/pdf' &&
        files.type !== 'image/tiff' &&
        files.type !== 'image/tif'
      ) {
        this.getModal(
          'Invalid file type, please upload a valid file.',
          constant.imageHeaderError
        )
        this.showSpinner = false
        return
      }

      if (files.size > constant.fileSize_5MB) {
        this.getModal(constant.fileSizeMessage_5MB, constant.imageHeaderError)
        this.isDisabled = false
        this.showSpinner = false
        this.signedFileName = ''
        return
      }
      this.signedFileName = this.signedfile.name
      this.authorizedFileItems[0].file_name = this.signedFileName
      this.fileType = files.type
      this.ConvertToBase64(files)
      this.isDisabled = true
    },

    f(pdf) {
      this.fileItemsTable.push({ file_name: pdf.name })
      this.$refs.modaldoc.style.display = 'none'
    },
    ConvertToBase64(pdf) {
      var fileReader = new FileReader()
      this.fileName = pdf.name
      var current = this
      fileReader.readAsDataURL(pdf)
      fileReader.onload = function(event) {
        current.fileData = event.target.result
        current.AuthorizationError = ''
        current.showSpinner = false
      }
    },
    onDeleteBorrowerInfo(borrowerItem) {
      this.borrowersInfo.splice(borrowerItem, 1)
      this.saveAndAddNewData.splice(borrowerItem, 1)
    },
    showUploadModal() {
      this.uploadDocumentModal = true
    },
    hideModalBox() {
      this.uploadDocumentModal = false
    },
    clearVoeData() {
      this.$emit('resetOrderReport')
    },
    clearFiles(index) {
      this.signedFileName = ''
      this.fileData = ''
      this.fileType = ''
      this.fileName = ''
      this.signedfile = null
      this.isDisabled = false
    },
  },
}
</script>
<template>
  <section>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <BaseAlert
      v-if="showmessage"
      class="w-25"
      :class="$style.alertMsgPosition"
      @alertDismissed="alertDismissed"
      @dismiss-count-down="countDownChanged"
    >
      {{ resultmessage }}
    </BaseAlert>
    <BaseSpinner v-if="showSpinner" />
    <b-row class="mt-4 mb-3">
      <b-col md="10">
        <b-form-radio-group
          v-model="employmentType"
          v-validate="{ required: true }"
          :options="employmentTypes"
          name="employmentType"
          class="mr-5"
          @change="onEmploymentTypeChange"
        />
        <div class="error">
          {{ errors.first('employmentType') }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="referenceNumber"
          v-model="referenceNumber"
          v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
          validattor="^[A-Za-z0-9-]+$"
          type="text"
          name="referenceNumber"
          maxlength="50"
          label-content="Reference Number"
          :placeholder="placeholders.referenceNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('referenceNumber') }}
        </div>
      </b-col>
      <b-col md="4" offset-md="1">
        <BaseELabel mark-required label="Permissible Purpose" />
        <BaseDropdown
          v-model="permissiblePurposeId"
          v-validate="'required'"
          data-vv-as="Permissible purpose"
          field-id="purposeId"
          :options="permissiblePurposes"
          class="mb-1"
          name="permissiblePurposeId"
        ></BaseDropdown>
        <div class="error">
          {{ errors.first('permissiblePurposeId') }}
        </div>
      </b-col>
    </b-row>
    <div v-if="employmentType !== 'Reverify'">
      <b-row class="mt-3" align-v="center">
        <b-col md="auto">
          <div>
            <BaseELabel
              :class="$style.labelSubHeading"
              label="Borrower Information"
            />
          </div>
        </b-col>
        <b-col class="border-bottom"></b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <BaseEInputText
            id="borrowerFirstName"
            v-model="borrowerFirstName"
            v-validate="{ required: true }"
            data-vv-as="First Name"
            type="text"
            name="borrowerFirstName"
            maxlength="50"
            label-content="First Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('borrowerFirstName'),
            }"
            :placeholder="placeholders.firstName"
            aria-describedby="firstName"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('borrowerFirstName') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="borrowerMiddleName"
            v-model="borrowerMiddleName"
            v-validate="{ required: false }"
            data-vv-as="Middle Name"
            type="text"
            name="borrowerMiddleName"
            maxlength="50"
            label-content="Middle Name"
            :class="{
              input: true,
              'is-danger': errors.has('borrowerMiddleName'),
            }"
            :placeholder="placeholders.middleName"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('borrowerMiddleName') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="borrowerLastName"
            v-model="borrowerLastName"
            v-validate="{ required: true }"
            data-vv-as="Last Name"
            type="text"
            name="borrowerLastName"
            maxlength="20"
            label-content="Last Name"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('borrowerLastName'),
            }"
            :placeholder="placeholders.lastName"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('borrowerLastName') }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <BaseEInputText
            id="borrowerSSN"
            v-model="borrowerSSN"
            v-validate="{
              required: true,
              regex: /^\d{3}-?\d{2}-?\d{4}$/,
            }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{2})(\d{4})"
            formatter="$1-$2-$3"
            type="text"
            maxlength="11"
            name="borrowerSSN"
            label-content="SSN"
            data-vv-as="SSN"
            mark-required
            :class="{
              input: true,
              'is-danger': errors.has('borrowerSSN'),
            }"
            :placeholder="placeholders.ssn"
          />
          <div class="error">
            {{ errors.first('borrowerSSN') }}
          </div>
        </b-col>
        <b-col v-show="!enableManualVerificationMandatory" md="3">
          <BaseEInputText
            id="salaryKey"
            v-model="salaryKey"
            v-validate="{
              regex: /^[a-zA-Z0-9]+$/,
            }"
            validattor="^[a-zA-Z0-9]+$"
            type="text"
            name="salaryKey"
            data-vv-as="Salary Key"
            maxlength="25"
            :placeholder="placeholders.salaryKey"
            label-content="Salary Key"
          />
          <div class="error">
            {{ errors.first('salaryKey') }}
          </div>
        </b-col>
        <b-col v-if="enableManualVerificationMandatory" md="3">
          <BaseELabel label="DOB" />
          <BaseDate
            v-model="borrowerDOB"
            type="date"
            :field-id="borrowerDOB"
            name="borrowerDOB"
            data-vv-as="Date of Birth"
            :class="{
              input: true,
              'is-danger': errors.has('borrowerDOB'),
            }"
          ></BaseDate>
          <div class="error">
            {{ errors.first('borrowerDOB') }}
          </div>
        </b-col>
      </b-row>
      <b-row v-if="enableManualVerificationMandatory">
        <b-col md="5">
          <BaseEInputText
            id="borrowerStreetAddress"
            v-model="borrowerStreetAddress"
            v-validate="{
              required: true,
            }"
            type="text"
            name="borrowerStreetAddress"
            maxlength="100"
            label-content="Street"
            data-vv-as="Street"
            mark-required
            :placeholder="placeholders.streetAddress"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('borrowerStreetAddress') }}
          </div>
        </b-col>
        <b-col md="3">
          <BaseEInputText
            id="borrowerCityName"
            v-model="borrowerCityName"
            v-validate="{ required: true, regex: /^[A-Za-z-. ]+$/ }"
            validattor="^[A-Za-z-. ]+$"
            type="text"
            name="borrowerCityName"
            maxlength="20"
            label-content="City"
            mark-required
            data-vv-as="City"
            :placeholder="placeholders.cityName"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('borrowerCityName') }}
          </div>
        </b-col>
        <b-col md="2">
          <BaseELabel mark-required label="State" />
          <BaseDropdown
            id="borrowerState"
            v-model="borrowerState"
            v-validate="'required'"
            :field-id="borrowerState"
            :options="states"
            class="mb-1"
            name="borrowerState"
            :placeholder="placeholders.state"
          ></BaseDropdown>
          <div v-show="errors.has('borrowerState')" class="error">
            State is required
          </div>
        </b-col>
        <b-col md="2">
          <BaseEInputText
            id="borrowerZip"
            v-model="borrowerZip"
            v-validate="{ required: true }"
            validattor="[0-9]"
            maskker="(\d{5})(\d{4})"
            formatter="$1-$2"
            type="text"
            maxlength="10"
            name="borrowerZip"
            label-content="Zip"
            data-vv-as="Zip"
            mark-required
            :placeholder="placeholders.zip"
          ></BaseEInputText>
          <div class="error"> {{ errors.first('borrowerZip') }} </div>
        </b-col>
      </b-row>
      <b-row v-if="enableManualVerificationMandatory">
        <b-col md="3">
          <BaseEInputText
            id="borrowerPhoneNumber"
            v-model="borrowerPhoneNumber"
            v-validate="{
              required: false,
              regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
            }"
            validattor="[0-9]"
            maskker="(\d{3})(\d{3})(\d{4})"
            formatter="($1) $2-$3"
            type="text"
            maxlength="14"
            name="borrowerPhoneNumber"
            label-content="Phone Number"
            data-vv-as="Phone Number"
            :placeholder="placeholders.phoneNumber"
          ></BaseEInputText>
          <div class="error">
            {{ errors.first('borrowerPhoneNumber') }}
          </div>
        </b-col>
      </b-row>
      <div v-if="enableManualVerificationMandatory">
        <b-row class="mt-3" align-v="center">
          <b-col md="auto">
            <div>
              <BaseELabel
                :class="$style.labelSubHeading"
                label=" Employer Information"
              />
            </div>
          </b-col>
          <b-col class="border-bottom"></b-col>
        </b-row>

        <b-row class="mt-4 mb-3">
          <b-col md="10">
            <b-form-radio-group
              v-model="employerType"
              v-validate="{ required: true }"
              :options="employerTypes"
              name="employerType"
              class="mr-5"
              @change="onEmploymentTypeChange"
            />
            <div v-show="errors.has('employerType')" class="error">
              Employee type is required
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <BaseEInputText
              id="employerName"
              v-model="employerName"
              v-validate="{ required: true }"
              data-vv-as="Employer Name"
              type="text"
              name="employerName"
              maxlength="50"
              label-content="Employer Name"
              mark-required
              :placeholder="placeholders.employerName"
              aria-describedby="employerName"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('employerName') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="employerPhoneNumber"
              v-model="employerPhoneNumber"
              v-validate="{
                required: true,
                regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
              }"
              validattor="[0-9]"
              maskker="(\d{3})(\d{3})(\d{4})"
              formatter="($1) $2-$3"
              type="text"
              maxlength="14"
              name="employerPhoneNumber"
              label-content="Phone Number"
              data-vv-as="Phone Number"
              mark-required
              :placeholder="placeholders.phoneNumber"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('employerPhoneNumber') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="employerFax"
              v-model="employerFax"
              v-validate="{
                required: false,
              }"
              validattor="[0-9]"
              maskker="(\d{5})(\d{4})"
              formatter="$1-$2"
              type="text"
              maxlength="10"
              name="employerFax"
              label-content="Fax Number"
              data-vv-as="fax"
              :placeholder="placeholders.fax"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('employerFax') }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <BaseEInputText
              id="employerStreetAddress"
              v-model="employerStreetAddress"
              v-validate="{
                required: true,
              }"
              type="text"
              name="employerStreetAddress"
              maxlength="100"
              label-content="Street"
              data-vv-as="Street"
              mark-required
              :placeholder="placeholders.streetAddress"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('employerStreetAddress') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="employerCityName"
              v-model="employerCityName"
              v-validate="{ required: true, regex: /^[A-Za-z-. ]+$/ }"
              validattor="^[A-Za-z-. ]+$"
              type="text"
              name="employerCityName"
              maxlength="20"
              label-content="City"
              mark-required
              data-vv-as="City"
              :placeholder="placeholders.cityName"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('employerCityName') }}
            </div>
          </b-col>
          <b-col md="2">
            <BaseELabel mark-required label="State" />
            <BaseDropdown
              v-model="employerState"
              v-validate="'required'"
              :field-id="employerState"
              :options="states"
              class="mb-1"
              name="employerState"
              :placeholder="placeholders.state"
            ></BaseDropdown>
            <div v-show="errors.has('employerState')" class="error">
              State is required
            </div>
          </b-col>
          <b-col md="2">
            <BaseEInputText
              id="employerZip"
              v-model="employerZip"
              v-validate="{ required: true }"
              validattor="[0-9]"
              maskker="(\d{5})(\d{4})"
              formatter="$1-$2"
              type="text"
              maxlength="10"
              name="employerZip"
              label-content="Zip"
              data-vv-as="Zip"
              mark-required
              :placeholder="placeholders.zip"
            ></BaseEInputText>
            <div class="error"> {{ errors.first('employerZip') }} </div>
          </b-col>
        </b-row>
        <b-row class="mt-3" align-v="center">
          <b-col md="auto">
            <div>
              <BaseELabel
                :class="$style.labelSubHeading"
                label="HR Contact Information"
              />
            </div>
          </b-col>
          <b-col class="border-bottom"></b-col>
        </b-row>

        <b-row>
          <b-col md="3">
            <BaseEInputText
              id="hrFirstName"
              v-model="hrFirstName"
              v-validate="{ required: true }"
              data-vv-as="First Name"
              type="text"
              name="hrFirstName"
              maxlength="50"
              label-content="First Name"
              mark-required
              :placeholder="placeholders.firstName"
              aria-describedby="firstName"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('hrFirstName') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="hrMiddleName"
              v-model="hrMiddleName"
              v-validate="{ required: false }"
              data-vv-as="Middle Name"
              type="text"
              name="hrMiddleName"
              maxlength="50"
              label-content="Middle Name"
              :placeholder="placeholders.middleName"
            ></BaseEInputText>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="hrLastName"
              v-model="hrLastName"
              v-validate="{ required: true, regex: /^[A-Za-z-. ]+$/ }"
              validattor="^[A-Za-z-. ]+$"
              data-vv-as="Last Name"
              type="text"
              name="hrLastName"
              maxlength="20"
              label-content="Last Name"
              mark-required
              :placeholder="placeholders.lastName"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('hrLastName') }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <BaseEInputText
              id="hrTitle"
              v-model="hrTitle"
              v-validate="{ required: false, regex: /^[A-Za-z-. ]+$/ }"
              validattor="^[A-Za-z-. ]+$"
              data-vv-as="Title"
              type="text"
              name="hrTitle"
              maxlength="20"
              label-content="Title"
              :placeholder="placeholders.hrTitle"
            ></BaseEInputText>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="hrPhoneNumber"
              v-model="hrPhoneNumber"
              v-validate="{
                required: false,
                regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
              }"
              validattor="[0-9]"
              maskker="(\d{3})(\d{3})(\d{4})"
              formatter="($1) $2-$3"
              type="text"
              maxlength="14"
              name="hrPhoneNumber"
              label-content="Phone Number"
              data-vv-as="Phone Number"
              :placeholder="placeholders.phoneNumber"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('hrPhoneNumber') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="hrFax"
              v-model="hrFax"
              v-validate="{
                required: false,
              }"
              validattor="[0-9]"
              maskker="(\d{5})(\d{4})"
              formatter="$1-$2"
              type="text"
              maxlength="10"
              name="hrFax"
              label-content="Fax Number"
              data-vv-as="fax"
              :placeholder="placeholders.fax"
            ></BaseEInputText>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <BaseEInputText
              id="hrEmail"
              v-model="hrEmail"
              v-validate="{
                required: true,
                regex: /\S+@\S+\.\S+/,
              }"
              maxlength="100"
              type="text"
              name="hrEmail"
              label-content="Email ID"
              data-vv-as="Email ID"
              mark-required
              :placeholder="placeholders.email"
            ></BaseEInputText>
            <div class="error">
              {{ errors.first('hrEmail') }}
            </div>
          </b-col>
        </b-row>
        <b-row class="pb-3 border-bottom">
          <b-col>
            <BaseTextarea
              id="additionalNotes"
              v-model="additionalNotes"
              v-validate="{ required: false }"
              maxlength="100"
              name="comments"
              label-content="Additional Notes"
            ></BaseTextarea>
          </b-col>
        </b-row>
      </div>
      <div v-if="!enableManualVerificationMandatory">
        <b-row class="mt-4 mb-2">
          <b-col md="auto">
            <BaseELabel size="md" label="Obtain VOE for Specific Employer ?" />
          </b-col>
          <b-col>
            <b-form-radio-group
              :key="obtainVoe.id"
              v-model="obtainVoe"
              v-validate="{
                required: true,
              }"
              :options="obtainVoes"
              name="obtainVoe"
              class="mr-5"
            />
            <div class="error">
              {{ errors.first('obtainVoe') }}
            </div>
          </b-col>
        </b-row>
        <b-row v-if="obtainVoe">
          <b-col md="3">
            <BaseEInputText
              id="employerName"
              v-model="employerName"
              v-validate="{
                required: false,
              }"
              type="text"
              data-vv-as="Employer Name"
              maxlength="100"
              name="employerName"
              label-content="Employer Name"
              :placeholder="placeholders.employerName"
            />
            <div class="error">
              {{ errors.first('employerName') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="employerCode"
              v-model="employerCode"
              v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
              validattor="^[A-Za-z0-9-]+$"
              name="employerCode"
              data-vv-as="Employer Code"
              maxlength="10"
              type="text"
              label-content="Employer Code"
              :placeholder="placeholders.employerCode"
            />
            <div class="error">
              {{ errors.first('employerCode') }}
            </div>
          </b-col>
          <b-col md="3">
            <BaseEInputText
              id="employeeId"
              v-model="employeeId"
              v-validate="{ required: false, regex: /^[A-Za-z0-9-]+$/ }"
              validattor="^[A-Za-z0-9-]+$"
              data-vv-as="Employee ID"
              maxlength="10"
              name="employeeId"
              type="text"
              label-content="Employee ID"
              :placeholder="placeholders.employeeId"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <BaseELabel size="md" label="Verify for" />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form-radio-group
              :key="verifyFors.id"
              v-model="verifyFor"
              v-validate="{
                required: true,
              }"
              data-vv-as="Verify For"
              :options="verifyFors"
              name="verifyFor"
              class="ml-3"
              stacked
            />
            <div class="error">
              {{ errors.first('verifyFor') }}
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row
        v-if="
          employmentType === 'EmploymentIncome' ||
            enableManualVerificationMandatory
        "
        class="my-3"
      >
        <BaseELabel
          size="md"
          :mark-required="isAuthFormRequired"
          label="Borrower's Authorization Form"
        />

        <b-col class="text-right my-2">
          <BaseEButton variant="cancel" @click="uploadDocumentModal = true">
            Upload Document
          </BaseEButton>
        </b-col>
        <b-col md="12">
          <b-table
            id="tblBorrowerAuthorization"
            class="text-center"
            hover
            striped
            bordered
            responsive="sm"
            :items="authorizedFileItems"
            :fields="authorizedTableFields"
          >
            <template v-slot:cell(file_name)>
              <b class="text-info">{{ signedFileName }} </b>
            </template>
            <template v-slot:cell(file_actions)="data">
              <div class="text-center">
                <BaseIcon
                  v-model="data.value"
                  name="times-circle"
                  :class="$style.delActionBtn"
                  @click="clearFiles"
                />
              </div>
            </template>
          </b-table>
        </b-col>
        <b-col md="12">
          <div class="error">
            {{ AuthorizationError }}
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row v-if="employmentType === 'Reverify'">
      <b-col md="3">
        <BaseEInputText
          id="previousOrder"
          v-model="previousOrder"
          v-validate="{
            required: true,
          }"
          type="text"
          data-vv-as="Previous Order#"
          maxlength="10"
          name="previousOrder"
          label-content="Previous Order#"
          mark-required
          :placeholder="placeholders.previousOrder"
        />
        <div class="error">
          {{ errors.first('previousOrder') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="lastDigitsOfSSN"
          v-model="lastDigitsOfSSN"
          v-validate="{ required: true, regex: /^[0-9]+$/ }"
          validattor="^[0-9]+$"
          name="lastDigitsOfSSN"
          data-vv-as="Last 4 digits of SSN"
          maxlength="4"
          type="text"
          mark-required
          label-content="Last 4 digits of SSN"
          :placeholder="placeholders.lastDigitsOfSSN"
        />
        <div class="error">
          {{ errors.first('lastDigitsOfSSN') }}
        </div>
      </b-col>
    </b-row>

    <b-row v-if="!reSubmitOrder">
      <b-col md="auto" class="ml-auto">
        <BaseEButton
          :disabled="borrowersInfo.length >= 13"
          @click="onSaveAnotherVOE"
        >
          Save and add another VOE
        </BaseEButton></b-col
      >
    </b-row>
    <b-row v-if="!reSubmitOrder" class="mt-2" align-h="center">
      <b-col>
        <b-table
          id="tblSaveAndAddBorrower"
          class="text-center"
          hover
          striped
          bordered
          responsive="sm"
          :items="saveAndAddNewData"
          :fields="saveAndAddNewBorrowerFields"
        >
          <template v-slot:cell(employeementType)="row">
            <p class="text-left m-0">
              <b class=" text-info">{{ row.item.employeementType }} </b>
            </p>
          </template>
          <template v-slot:cell(borrowerName)="row">
            <p class="text-left m-0">
              <b class=" text-info">{{ row.item.borrowerName }} </b>
            </p>
          </template>
          <template v-slot:cell(Actions)="row">
            <b-link v-b-tooltip.hover.left="'Delete'">
              <BaseIcon
                noninteractive
                size="lg"
                name="times-circle"
                class="m-1"
                @click.native.prevent="onDeleteBorrowerInfo(row.index)"
              />
            </b-link>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="border-bottom pb-3" />
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <BaseEButton @click="onReportSubmit">
          Order
        </BaseEButton>
        <BaseEButton
          v-show="enableManualVerificationMandatory"
          variant="cancel"
          @click="onCancelClick"
          >Cancel</BaseEButton
        >
      </b-col>
    </b-row>
    <div>
      <BaseModalLayout
        :show-modal="uploadDocumentModal"
        modal-title="Upload Document"
        modal-size="lg"
        ok-variant="Upload"
        cancel-variant="Cancel"
        @confirmOkClicked="onChangePdf"
        @confirmCancelClicked="uploadDocumentModal = false"
      >
        <b-row class="pt-2">
          <b-col>
            <BaseELabel label="Upload .PDF file with maximum size of 5 MB" />
          </b-col>
        </b-row>
        <b-row class="pb-3">
          <b-col>
            <div class="d-block text-center">
              <div>
                <b-form-file
                  id="signedfile"
                  ref="file-input"
                  v-model="signedfile"
                  :validate="'required'"
                  accept="application/pdf"
                  drop-placeholder="Drop file here..."
                  class="text-left"
                  :class="$style.textellipsis"
                ></b-form-file>
              </div>
            </div>
          </b-col>
        </b-row>
      </BaseModalLayout>
    </div>
    <div>
      <BaseModalConfirm
        :modal-show="showModalConfirm"
        :title-header="confirmTitle"
        :alert-message="confirmMessage"
        ok-variant="Ok"
        cancel-variant="Cancel"
        @confirmOkClicked="clearVoeData"
        @confirmCancelClicked="hideModalAlert"
      >
      </BaseModalConfirm>
    </div>
  </section>
</template>

<style lang="scss" module>
@import '@design';
.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
.alertMsgPosition {
  position: absolute;
  top: 350px;
  right: 0;
}
.textellipsis {
  padding-right: 84px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
